import React from 'react';
import { connect } from 'react-redux';

import { getLengthUnit } from '../../../../reducers';
import MenuDrawer from './MenuDrawer';

export const MenuDrawerContainer = (props) => (
  <MenuDrawer {...props} />
) 

function mapStateToProps(state){
  return { lengthUnit:    getLengthUnit(state) }
}

export default connect(mapStateToProps)(MenuDrawer);



// WEBPACK FOOTER //
// ./src/components/StackupDesign/Viewer/MenuDrawer/MenuDrawerContainer.js